import { StreamFormat } from "./wasm.model";

/**
 * Timeslices for how much audio to send to wasm at one time.
 */
export const AUDIO_BLOB_MILLIS = 500;

export interface AudioStreamStartResult {
  mediaRecorder?: MediaRecorder;
  error?: string;
}

export interface MediaRecorderMeta {
  id: number;
  streamFormat: StreamFormat;
}

/**
 * Incremental blobs of audio data.
 */
export type OnAudioDataAvailable = (args: { pcmBlob: Blob; rawBlob?: Blob; sampleRate: number }) => void;

// This hero did a bunch of browser compat research: https://github.com/chrisguttandin/extendable-media-recorder/blob/master/src/factories/media-recorder-constructor.ts
// Net: I would have to throw away the webm stuff to read PCM on other browsers.

export const WEBM_PCM_MIME_TYPE = "audio/webm; codecs=pcm";

export const IS_WEBM_PCM_SUPPORTED = MediaRecorder.isTypeSupported(WEBM_PCM_MIME_TYPE);
export const UNSUPPORTED_BROWSER_ERROR = "Firefox and Safari browsers are not supported, please use Chrome or Edge.  More info in the FAQ.";

// export function getAudioMimeType() {
//   if (MediaRecorder.isTypeSupported(CHROME_WEBM_PCM)) {
//     return CHROME_WEBM_PCM;
//   }
//   // This interface to ask "what is supported" varies by browser. Hilarious.
//   // navigator.mediaCapabilities.encodingInfo({ type: "record" (chrome) or "file" (firefox)});
// }
// "audio/webm;codecs=opus"; <-- parsing Opus is hard; C lib which does it is big and there are many issues getting it into wasm.
// Prefer PCM because (1) it's simple and (2) the data is only streamed locally so bandwidth is not a big deal.

/**
 * The lack of granularity in lowend made this unusable. (histogram bin bandwidth was not linear)
 */
// export function createAnalyzerNode(audioCtx: AudioContext): AnalyserNode {
//   const analyzer = audioCtx.createAnalyser();
//   analyzer.fftSize = 32768; // actual sample rate is half of this.  Huge... OS default sample rate is 48K.  TODO: downsample
//   analyzer.minDecibels = -75; // default -100db.. see if this reduces noise.
//   analyzer.smoothingTimeConstant = 0.1;
//   return analyzer;
// }
